import { Monitoring } from '@grammarly/telemetry'
import { getConfig } from '../../../config'
import { BUILD_TAG, SERVICE_NAME, GR_ENV } from '../../../constants'
import { redactPiiFromUrl } from '../../utils/pii'

const felogUrl = getConfig().tracking.felog.url

export enum LogLevel {
  Info = 'INFO',
  Warn = 'WARN',
  Error = 'ERROR',
}

export function sendFelogEvent(
  message: string,
  logLevel: LogLevel = LogLevel.Info,
  logger: string,
  extraInfo = {}
): Promise<unknown> | undefined {
  if (!IS_CLIENT_SIDE) {
    Monitoring.Logging.getLogger('felog.event').warn(
      "Server side wants to send felog event, but it isn't allowed at the server side.",
      {
        message,
        logLevel,
        logger,
        extra: extraInfo,
      }
    )
    return
  }

  const data = {
    application: SERVICE_NAME,
    version: BUILD_TAG,
    env: GR_ENV,
    level: logLevel,
    message,
    logger,
    extra: {
      ...extraInfo,
      url: redactPiiFromUrl(document.location.href),
      pathname: document.location.pathname,
    },
  }

  return fetch(felogUrl + '/log', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).catch((_) => {
    // no-op
  })
}
